module.exports = __webpack_public_path__ + "static/adocumentation-cee1d9a0a98ff8c26d8d47e01f39793d.png";